import React from "react";

export function DetailPanel({title, children, className = ""}) {
    const showHead = title != null && title !== "";

    return (
        <div className={`detail-list-panel asset-detail-panel ${className}`.trim()}>
            {showHead && (
                <div className="detail-list-panel-head asset-detail-panel-head">{title}</div>
            )}
            <div className="detail-list-panel-body asset-detail-panel-body">{children}</div>
        </div>
    );
}
